<template>
  <section class="container">
    <p>部分案例仅供参考，以下排名不分先后顺序</p>
    <case-list v-if="list.length>0" :dataList="list"></case-list>
  </section>
</template>

<script>
import { wllib } from '../../utils/index'
import CaseList from './comps/caseList.vue'
export default {
  components: { CaseList },
  name: 'enterprise',
  data() {
    return {
      list: [],
      pageData: {
        pageNum: 1,
        pageSize: 200,
        total: 0
      },
    }
  },
  methods: {
    loadData() {
      let { pageNum, pageSize } = this.pageData
      let req = {
        customerType: '医院/企业',
        pageNum: pageNum,
        pageSize: pageSize
      }
      wllib.net.wlGet(Config.ajaxUrl + "/customer/list", req).then((res) => {
        let { rows } = res.data
        this.list = rows
        this.list.forEach((item)=>{
          item.realLogoUrl = Config.ajaxUrl + item.logoUrl
        })
      })
    },
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang='scss' scoped>
p {
  font-size: 20px;
  line-height: 20px;
  color: #6d6d6d;
  padding: 65px 0;
}
.container {
  overflow: hidden;
  padding-bottom: 90px;
}
</style>